exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".iziToast[data-v-0ba8860c] {\n  border-radius: 0;\n}\n", "", {"version":3,"sources":["/home/vsts/work/1/s/apps/client/landing/src/molecules/notification/Notification.vue"],"names":[],"mappings":"AAOA;EACI,iBAAgB;CAAA","file":"Notification.vue?vue&type=style&index=0&id=0ba8860c&lang=scss&scoped=true&","sourcesContent":["@import \"../../../../common/styles/user-variables\";\n@import \"../../../../vendor/createx/styles/helpers\";\n@import \"~bootstrap/scss/functions\";\n@import \"~bootstrap/scss/variables\";\n@import \"~bootstrap/scss/mixins\";\n\n\n.iziToast {\n    border-radius: 0;\n}\n"],"sourceRoot":""}]);

// exports
